// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function formatDateTime(date: Date, options: any): string {
  const formatOptions: Intl.DateTimeFormatOptions = {
    timeZone:
      options.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: options.timeFormat === "12h",
  };

  if (options.showSeconds !== false) {
    formatOptions.second = "2-digit";
  }

  if (options.dateFormat) {
    switch (options.dateFormat) {
      case "short":
        formatOptions.day = "2-digit";
        formatOptions.month = "2-digit";
        formatOptions.year = "numeric";
        break;
      case "long":
        formatOptions.day = "numeric";
        formatOptions.month = "long";
        formatOptions.year = "numeric";
        break;
      case "weekday":
        formatOptions.weekday = "long";
        formatOptions.day = "numeric";
        formatOptions.month = "long";
        break;
    }
  }

  const locale = options.locale || "es-ES";
  return new Intl.DateTimeFormat(locale, formatOptions).format(date);
}
